import { useQuery } from '@apollo/client';
import { GET_PENDING_APPROVALS } from 'gql/pendingApprovals';
import { ENUM_PROJECT_STATUS_CONTROL_TYPE } from 'constants/form';

const useCountPendingApprovals = () => {
  const { data, loading } = useQuery(GET_PENDING_APPROVALS, {
    variables: {
      ignoreNotAuthorised: true,
    },
    errorPolicy: 'all',
  });

  const count = {
    extensions:
      data?.myPendingApprovals?.extensions
        ?.filter(Boolean)
        .filter(
          ({ isCurrentAppointedApprover, project }) =>
            isCurrentAppointedApprover &&
            project?.projectStatus?.controlType ===
              ENUM_PROJECT_STATUS_CONTROL_TYPE.IN_PROGRESS
        ).length || 0,
    virements:
      data?.myPendingApprovals?.virements
        ?.filter(Boolean)
        .filter(
          ({ isCurrentAppointedApprover, project }) =>
            isCurrentAppointedApprover &&
            project?.projectStatus?.controlType ===
              ENUM_PROJECT_STATUS_CONTROL_TYPE.IN_PROGRESS
        ).length || 0,
    proposalRevisions:
      data?.myPendingApprovals?.proposalRevisions
        ?.filter(Boolean)
        .filter(
          ({ isCurrentAppointedApprover, project }) =>
            isCurrentAppointedApprover &&
            project?.projectStatus?.controlType ===
              ENUM_PROJECT_STATUS_CONTROL_TYPE.IN_PROGRESS
        ).length || 0,
    withdrawals:
      data?.myPendingApprovals?.withdrawals
        ?.filter(Boolean)
        .filter(
          ({ isCurrentAppointedApprover, project }) =>
            isCurrentAppointedApprover &&
            project?.projectStatus?.controlType ===
              ENUM_PROJECT_STATUS_CONTROL_TYPE.IN_PROGRESS
        ).length || 0,
    reportSubmissions:
      data?.myPendingApprovals?.reportSubmissions
        ?.filter(Boolean)
        .filter(
          ({ isCurrentAppointedReviewer, project }) =>
            isCurrentAppointedReviewer &&
            project?.projectStatus?.controlType ===
              ENUM_PROJECT_STATUS_CONTROL_TYPE.IN_PROGRESS
        ).length || 0,
    projectApplications: data?.projectApplications?.totalCount,
  };

  count.total =
    count.extensions +
    count.virements +
    count.proposalRevisions +
    count.withdrawals +
    count.reportSubmissions +
    count.projectApplications;
  return { count, loading };
};

export default useCountPendingApprovals;
